import LogRocket from 'logrocket';
// --- external imports ------

// The other half of logging in.
//
// Logging in tells Heap the player's email and LogRocket their uid, email and
// full name; nothing ever told either of them to forget. On a machine more than
// one person uses — a classroom, a lab, a shared demo laptop — that means the
// player who logs in next has their clicks and their session recording filed
// under the previous player's name and email address, at two third parties,
// until a new login happens to overwrite it. A player who never logs in at all
// is worse: they are simply recorded as the person before them. So every way
// out of a session comes through here, and it is called on the way out rather
// than on the way in, because the next login is not guaranteed to arrive.
//
// Imported statically on purpose: `logrocket` is already in the bundle the auth
// screens load — `src/index.js` pulls it in at module scope for `LogRocket.init`
// — so naming it here costs nothing. The Dexie note in `logOutPlayer` does not
// apply.
//
// Nothing in here may throw. Every caller is a path that ends a session, and an
// analytics SDK that was unhappy must never be the reason a player could not get
// out.
export default function resetAnalyticsIdentity() {
	try {
		// Guarded the way the two `identify` calls it undoes are guarded: the Heap
		// snippet may not have installed `window.heap` at all, and when Heap is
		// disabled `src/index.js` replaces its methods with no-ops — which is why
		// the method itself is called optionally as well as the object checked.
		if (window.heap) {
			window.heap.resetIdentity?.();

			// `resetIdentity` starts a new anonymous user, which is enough for the
			// user properties — `latestGameUserId` stays with the user who had it.
			// Event properties are not part of an identity, though: `gameUserId`,
			// set in `~/store/game/actions`, is attached to the session and would
			// ride along on the next player's events until their own game load
			// overwrote it. Removed by name rather than with `clearEventProperties`,
			// which would take anything else the app has put there with it.
			window.heap.removeEventProperty?.('gameUserId');
		}
	}
	catch (error) {
		console.error('Failed to reset the Heap identity.', error);
	}

	try {
		// LogRocket has no unidentify. Version 10 offers `identify` and
		// `startNewSession` and nothing that strips the traits already attached to
		// a session, so the only way to stop the recording from here on being
		// filed under the player who just left is to end their session: whatever
		// the next person does lands in a fresh, anonymous one instead.
		LogRocket.startNewSession();
	}
	catch (error) {
		console.error('Failed to start a new LogRocket session.', error);
	}
}
